// Third Party
import { map } from "rxjs/operators";
import { ofType } from "redux-observable";

// Project
import { DRAFT_ATTACHMENT_ADD_SUCCESS } from "../../constants/ActionTypes.js";
import { draftSelected } from "../../actions/draftMessageActions";

const draftAttachmentAddSuccessEpic = action$ => action$.pipe(
  ofType(DRAFT_ATTACHMENT_ADD_SUCCESS),
  map(action => draftSelected(action.mailboxAddress, action.draftIdentity))
);

export default draftAttachmentAddSuccessEpic;
